import type { ClockResources } from './en-US.js';

export const zhHant: ClockResources = {
  nav: {
    clock: '打卡',
    records: '出勤記錄',
    requests: '更正申請',
    approvals: '審核',
    team: '團隊',
    schedules: '班表',
  },
  clock: {
    now: '目前時間（{{timeZone}}）',
    status: '狀態',
    since: '自 {{time}}',
    today: '今日打卡',
    noPunches: '今天尚未打卡。',
    recorded: '已於 {{time}} 記錄。',
    needsCorrection:
      '{{dates}} 開始的工作已在上班 24 小時後自動下班。請提出更正申請，填寫實際的下班時間。',
    requestCorrection: '申請更正',
    endAgainHint: '再次點選「下班」可更新下班時間。',
    location: {
      title: '位置',
      granted: '已允許使用位置資訊。',
      prompt: '打卡時瀏覽器會詢問是否使用您的位置。',
      denied: '位置資訊已被封鎖。請在瀏覽器設定中允許後再打卡。',
      unsupported: '此瀏覽器無法取得位置。',
      locating: '正在取得位置…',
    },
    error: {
      title: '需要位置資訊',
      denied: '此網站的位置權限已被封鎖。請在瀏覽器的網站設定中允許位置存取，然後再試一次。',
      unavailable: '無法取得您的位置。請確認裝置已開啟定位服務，然後再試一次。',
      timeout: '取得位置的時間過長。請移動到收訊較好的地方，然後再試一次。',
      unsupported: '此瀏覽器無法取得位置。請使用其他瀏覽器或裝置打卡。',
    },
  },
  records: {
    title: '出勤記錄',
    titleOf: '{{name}} 的出勤記錄',
    previousMonth: '上個月',
    nextMonth: '下個月',
    date: '日期',
    schedule: '班表',
    actual: '工作時段',
    breaks: '休息',
    worked: '工作時間',
    late: '遲到',
    earlyLeave: '早退',
    overtime: '加班',
    holidayWork: '休息日工作',
    notes: '備註',
    dayOff: '休息日',
    missingPunch: '漏打卡',
    modified: '已更正',
    pending: '申請中',
    outsideGeofence: '範圍外打卡',
    endUpdated: '下班時間已更新',
    autoEnded: '自動下班',
    totals: '本月合計',
    calendar: '日曆',
    daysWorked: '出勤天數',
    lateCount: '遲到次數',
    earlyLeaveCount: '早退次數',
    missingPunches: '漏打卡',
    exportMonth: '月報（CSV）',
    exportYear: '年報（CSV）',
  },
  day: {
    back: '返回出勤記錄',
    schedule: '班表',
    noSchedule: '無班表',
    noRecord: '當天沒有記錄。',
    breaks: '休息',
    noBreaks: '無休息',
    punches: '打卡',
    showOnMap: '地圖',
    evidence: '打卡詳情（主管與管理員可見）',
    ip: 'IP 位址',
    accuracy: '精確度',
    geofence: '地理圍欄',
    nearestArea: '最近的區域',
    distance: '距離',
    meters: '{{value}} 公尺',
    requests: '更正申請',
    requestChange: '申請更正',
  },
  request: {
    title: '更正申請',
    hint: '請輸入應記錄的時間，包括所有休息。主管核准後生效。',
    workDate: '工作日期',
    start: '開始',
    end: '結束',
    breaks: '休息',
    addBreak: '新增休息',
    removeBreak: '刪除休息',
    breakStart: '休息開始',
    breakEnd: '休息結束',
    reason: '原因',
    submit: '送出申請',
  },
  requests: {
    title: '更正申請',
    empty: '尚無申請。',
    newRequest: '新增申請',
    withdraw: '撤回',
    requestedAt: '申請時間 {{time}}',
    reviewedBy: '{{name}}，{{time}}',
    comment: '備註',
    requested: '申請內容',
    current: '目前記錄',
  },
  approvals: {
    title: '審核',
    empty: '沒有待審核的申請。',
    comment: '備註（選填）',
  },
  team: {
    title: '團隊',
    today: '今天',
    month: '本月',
    group: '群組',
    allGroups: '所有群組',
    member: '成員',
    state: '狀態',
    since: '開始',
    warnings: '提醒',
    outsideGeofence: '在範圍外打卡',
    needsCorrection: '有需要更正的工作記錄',
    pendingRequests: '{{count}} 個申請',
    worked: '工作時間',
    daysWorked: '天數',
    overtime: '加班',
    late: '遲到',
    missingPunches: '漏打卡',
    outsideDays: '範圍外',
    empty: '沒有成員。',
  },
  schedules: {
    title: '班表',
    group: '群組',
    groupDefault: '群組預設班表',
    individual: '個人班表',
    member: '成員',
    effectiveFrom: '生效日期',
    weekday: '星期',
    workday: '工作日',
    start: '開始',
    end: '結束',
    breakMinutes: '休息（分鐘）',
    overnightHint: '結束時間早於或等於開始時間表示隔天結束。',
    versions: '版本',
    inEffect: '生效中',
    empty: '尚無班表。',
    saved: '班表已儲存。',
    useGroupDefault: '沒有個人班表，適用群組預設班表。',
  },
  geofences: {
    title: '地理圍欄',
    description: '不在群組任何啟用區域內的打卡會被接受，但會向主管與管理員標示。',
    name: '名稱',
    latitude: '緯度',
    longitude: '經度',
    radius: '半徑（公尺）',
    active: '啟用',
    add: '新增區域',
    mapHint: '點擊地圖可移動中心點。',
    empty: '此群組沒有區域。',
  },
  audit: {
    title: '稽核記錄',
    time: '時間',
    actor: '執行者',
    action: '操作',
    target: '對象',
    system: '系統',
    actions: {
      ScheduleChanged: '班表變更',
      GeofenceChanged: '地理圍欄變更',
      ModificationRequested: '提出更正申請',
      ModificationApproved: '核准更正申請',
      ModificationRejected: '駁回更正申請',
      ModificationCancelled: '撤回更正申請',
      CsvExported: '匯出 CSV',
      LocalAdminGranted: '新增管理員',
      LocalAdminRevoked: '移除管理員',
    },
  },
};
